export type { GhostTextPluginProps } from './GhostText';
export { GhostTextPlugin } from './GhostText';
export type { SerializedGhostTextNode } from './GhostText.node';
export { $createGhostTextNode, $isGhostTextNode, GhostTextNode } from './GhostText.node';
